module.exports = (__webpack_require__(9))(849);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@ant-design/icons/lib/dist.js from dll-reference antd_library
// module id = 919
// module chunks = 42